export enum TorqueUnit {
  Nm,
  Ncm,
  Ftlb,
  Inlb,
  Kgcm,
  Kgm,
}
